import React from "react";
import img1 from "../../images/main-banner-1.jpg";
import img2 from "../../images/main-banner.jpg";
import img3 from "../../images/catbanner-01.jpg";
import img4 from "../../images/catbanner-02.jpg";
import img5 from "../../images/catbanner-03.jpg";
import img6 from "../../images/catbanner-04.jpg";
// import product images
import productimg1 from "../../images/productsBlocks/mobile.jpg";
import productimg2 from "../../images/productsBlocks/labtop.jpg";
import productimg3 from "../../images/productsBlocks/camera.jpg";
import productimg4 from "../../images/productsBlocks/acc.jpg";
import productimg5 from "../../images/productsBlocks/acessories.jpg";
import productimg6 from "../../images/productsBlocks/tv.jpg";
import productimg7 from "../../images/productsBlocks/air_condition.jpg";
import productimg8 from "../../images/productsBlocks/personalcare.jpg";
// import random products
import randomprosucimg1 from "../../images/random_products/subbanner-01.jpg";
import randomprosucimg2 from "../../images/random_products/subbanner-02.webp";
import randomprosucimg3 from "../../images/random_products/subbanner-03.webp";
import randomprosucimg4 from "../../images/random_products/subbanner-04.webp";
// import LatestNews images
import latestnewsimg1 from "../../images/LatestNews/blog-1_405x.webp";
import latestnewsimg2 from "../../images/LatestNews/blog-2_405x.webp";
import latestnewsimg3 from "../../images/LatestNews/blog-3_405x.webp";
import latestnewsimg4 from "../../images/LatestNews/blog-4_405x.webp";
import latestnewsimg5 from "../../images/LatestNews/blog-5_405x.webp";
// import swipper
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Pagination } from "swiper";
// import icons
import { TbTruckDelivery } from "react-icons/tb";
import { BiSupport } from "react-icons/bi";
import { GiPriceTag } from "react-icons/gi";
import { MdPayment } from "react-icons/md";
import { AiFillGift } from "react-icons/ai";
// import css file
import "./home.css";

import Productscardscontainer from "../../containers/productscards/Productscards";
import RandomProducts from "../../components/random_products/random_products";
import BrandsName from "../../containers/Brandsn_Name/Brands_Name";
import LatestNewsBlock from "../../components/LatestNews/LatestNewsBlock";
import PopularProducts from "../../containers/PopularProducts/PopularProducts";
import { Link } from "react-router-dom";
const Home = () => {
  const showloaderr = () => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      <div className="home py-3">
        <div className="container-fluid">
          {/* start header */}
          <div className="header">
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <Swiper
                  slidesPerView={1}
                  spaceBetween={30}
                  pagination={{
                    clickable: true,
                  }}
                  modules={[Pagination]}
                  className="mySwiper"
                >
                  <SwiperSlide>
                    <div className="left-block position-relative  p-1">
                      <img
                        src={img1}
                        alt="left-blockimg"
                        className="img-fluid rounded-3"
                      ></img>
                      <div className="left-block-content position-absolute px-3">
                        <h3>SUPERCHARGED FOR PROS.</h3>
                        <h2>iPad S13+ Pro.</h2>
                        <p>From $999.00 or $41.62/mo. for 24 mo. Footnote*</p>
                        <button>Buy Now</button>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="left-block position-relative  p-1">
                      <img
                        src={img2}
                        alt="left-blockimg"
                        className="img-fluid rounded-3"
                      ></img>
                      <div className="left-block-content position-absolute px-3">
                        <h3>SUPERCHARGED FOR PROS.</h3>
                        <h2>Special Sale.</h2>
                        <p>From $999.00 or $41.62/mo. for 24 mo. Footnote*</p>
                        <button>Buy Now</button>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <div className="right-div d-flex flex-wrap justify-content-between align-items-center gap-10">
                  <div className="right_div_block">
                    <img src={img3} alt="right_div-img"></img>
                    <div className="right_div_content">
                      <h4> New arrival</h4>
                      <h2>Laptops max</h2>
                      <p>From $1699.00 or $64.62/mo.</p>
                    </div>
                  </div>
                  <div className="right_div_block">
                    <img src={img4} alt="right_div-img"></img>
                    <div className="right_div_content">
                      <h4>Best sale</h4>
                      <h2>Buy iPad air</h2>
                      <p>From $599 or $49.91/mo. for 12 mo. *</p>
                    </div>
                  </div>
                  <div className="right_div_block">
                    <img src={img5} alt="right_div-img"></img>
                    <div className="right_div_content">
                      <h4> 15% off</h4>
                      <h2>smartwatch 7</h2>
                      <p>Shop the latest band styles and colors.</p>
                    </div>
                  </div>
                  <div className="right_div_block">
                    <img src={img6} alt="right_div-img"></img>
                    <div className="right_div_content">
                      <h4> Free engraving</h4>
                      <h2>AirPods max</h2>
                      <p>High-fidelity playback & ultra-low distortion.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* start free shipping */}
          <div className="freeshiping">
            <div className="freeshiping_block">
              <TbTruckDelivery />
              <div className="description">
                <h3>Free Shiping</h3>
                <p>From all orders over $100</p>
              </div>
            </div>

            <div className="freeshiping_block">
              <AiFillGift />
              <div className="description">
                <h3>Daily Surprise Offers</h3>
                <p>Save up to 25% off</p>
              </div>
            </div>

            <div className="freeshiping_block">
              <BiSupport />
              <div className="description">
                <h3>Support 24/7</h3>
                <p>Shop with an expert</p>
              </div>
            </div>

            <div className="freeshiping_block">
              <GiPriceTag />
              <div className="description">
                <h3>Affordable Prices</h3>
                <p>Get Factory direct price</p>
              </div>
            </div>

            <div className="freeshiping_block">
              <MdPayment />
              <div className="description">
                <h3>Secure Payments</h3>
                <p>100% Protected Payments</p>
              </div>
            </div>
          </div>

          {/* start products */}
          <div className="products">
            <div className="products-content">
              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    smart phones & tablets
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg1}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    Laptops{" "}
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg2}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    Cameras
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg3}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    AirBods
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg4}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    Accessories
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg5}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    smart Tv
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg6}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    Air Conditions
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg7}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>

              <div className="product_block">
                <div className="product_block_name">
                  <Link to={"/OurStore"} onClick={() => showloaderr()}>
                    Personal Cares
                  </Link>
                  <p>24 items</p>
                </div>
                <img
                  src={productimg8}
                  alt="productimg"
                  style={{ width: "35%" }}
                ></img>
              </div>
            </div>
          </div>

          {/* start product cards */}
          <div
            className="productsCards"
            style={{ backgroundColor: "#F5F5F7", padding: "10px 10px" }}
          >
            <h5>Featured Collection</h5>
            <Productscardscontainer />
          </div>

          {/* start random products  */}
          <div
            className="random-sectoin"
            style={{ backgroundColor: "#F5F5F7", padding: "20px 10px" }}
          >
            <Swiper
              loop={true}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                // when window width is >= 480px
                480: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                // when window width is >= 640px
                640: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                992: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
              className="mySwiper productsSwipper"
              style={{ height: "457px" }}
            >
              <SwiperSlide className="first">
                <RandomProducts
                  subtitle={"big screen"}
                  title={"Smart Watch Series 7"}
                  description={"From $399or $16.62/mo. for 24 mo.*"}
                  img={randomprosucimg1}
                />
              </SwiperSlide>

              <SwiperSlide>
                <RandomProducts
                  subtitle={"Studio Display"}
                  title={"600 nits of brightness."}
                  description={"27-inch 5K Retina display"}
                  img={randomprosucimg2}
                />
              </SwiperSlide>

              <SwiperSlide>
                <RandomProducts
                  subtitle={"Studio Display"}
                  title={"600 nits of brightness."}
                  description={"27-inch 5K Retina display"}
                  img={randomprosucimg4}
                />
              </SwiperSlide>

              <SwiperSlide>
                <RandomProducts
                  subtitle={"smartphones"}
                  title={"Smartphone 13 Pro."}
                  description={
                    "Now in Green. From $999.00 or $41.62/mo for 24 mo. Footnote*"
                  }
                  img={randomprosucimg3}
                />
              </SwiperSlide>
            </Swiper>
          </div>
          {/* start popular products */}
          <PopularProducts />
          {/* start brands name */}
          <BrandsName />

          {/* start Latest Nesw */}
          <div
            className="Latest_news "
            style={{
              position: "relative",
              backgroundColor: "#F5F5F7",
              padding: "60px 10px",
            }}
          >
            <h5>Our Latest News</h5>
            <div className="productsCards-body"></div>
            <div className="productscards_content py-4">
              <Swiper
                loop={true}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  // when window width is >= 480px
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  // when window width is >= 640px
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                  },
                }}
                className="mySwiper productsSwipper"
                style={{ height: "457px" }}
              >
                <SwiperSlide>
                  <LatestNewsBlock
                    img={latestnewsimg1}
                    date={"11 June, 2022"}
                    title={" Sed ut perspiciatis unde omnis renaissance"}
                    description={
                      "To enjoy alternately the sight of their distress. He really shouted with pleasure"
                    }
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <LatestNewsBlock
                    img={latestnewsimg2}
                    date={"11 June, 2022"}
                    title={" Vitae magnis fusce laoreet porttitor hampden"}
                    description={
                      "You’re only as good as your last collection, which is an enormous pressure "
                    }
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <LatestNewsBlock
                    img={latestnewsimg3}
                    date={"11 June, 2022"}
                    title={"Urna pretium elit mauris cursus curabitu"}
                    description={
                      "To enjoy alternately the sight of their distress. He really shouted with pleasure"
                    }
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <LatestNewsBlock
                    img={latestnewsimg4}
                    date={"11 June, 2022"}
                    title={"Risus retium tortor metus classical literature"}
                    description={
                      "Duis aute irure dolor in reprehenderit in voluptate "
                    }
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <LatestNewsBlock
                    img={latestnewsimg5}
                    date={"11 June, 2022"}
                    title={"Urna pretium elit mauris cursus curabitu"}
                    description={
                      "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum  "
                    }
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
